query MfaSessionScans($runId: ConditionID!, $scanIdFilter: ConditionID, $limit: Int = 1000) {
	scans(run_id_eq: $runId, scan_id_eq: $scanIdFilter, limit: $limit) {
		scan_id
		created_at
	}
}
